import { toast } from 'sonner';

export const displayToastError = (title: string) => {
  toast.error(title, {
    duration: 5000,
    style: {
      background: 'hsl(var(--background))',
      color: 'hsl(var(--destructive))',
      border: '1px solid hsl(var(--destructive))',
      borderRadius: '6px',
    },
  });
};

export const displayToastSuccess = (title: string) => {
  toast.success(title, {
    duration: 5000,
    style: {
      background: 'hsl(var(--background))',
      color: 'hsl(142 76% 36%)', // Green color
      border: '1px solid hsl(142 76% 36%)',
      borderRadius: '6px',
    },
  });
};

export const displayToastInfo = (title: string) => {
  toast.info(title, {
    duration: 5000,
    style: {
      background: 'hsl(var(--background))',
      color: 'hsl(var(--foreground))',
      border: '1px solid hsl(var(--border))',
      borderRadius: '6px',
    },
  });
};
